import { render, staticRenderFns } from "./nutritionLibrary.vue?vue&type=template&id=3d676705&scoped=true&"
import script from "./nutritionLibrary.vue?vue&type=script&lang=js&"
export * from "./nutritionLibrary.vue?vue&type=script&lang=js&"
import style0 from "./nutritionLibrary.vue?vue&type=style&index=0&id=3d676705&prod&lang=scss&scoped=true&"
import style1 from "./nutritionLibrary.vue?vue&type=style&index=1&id=3d676705&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d676705",
  null
  
)

export default component.exports